import { EventEmitter } from 'events';
import EventListingService from './EventListingService';
import productionsFilter from './productionsFilter';
import { endOfDay } from '../date/DateHelpers';
import AnalyticsService from '../../../analytics/AnalyticsService';

class DataStore extends EventEmitter {
  constructor(dataTransform = null, config = null) {
    super();
    this.lastResult = null;
    this.lastRequestData = null;
    this.dataTransform = dataTransform;
    this.config = config;
  }

  fetchData = async ({ startDate, endDate }, keywords) => {
    if (this.config) {
      const { earliestEventDate, latestEventDate } = this.config;

      if (earliestEventDate && earliestEventDate > startDate) {
        startDate = earliestEventDate;
      }

      if (latestEventDate) {
        const latestEventDateEndOfDay = endOfDay(latestEventDate);

        if (latestEventDateEndOfDay < endDate && latestEventDateEndOfDay >= startDate) {
          endDate = latestEventDateEndOfDay;
        }
      }
    }

    const requestData = {
      startDate,
      endDate,
      keywords,
    };

    if (this.isLastResultReusable(requestData)) {
      return this.lastResult;
    }

    this.emit('fetchStart');

    this.lastRequestData = requestData;
    let data = null;
    try {
      data = await EventListingService.post(requestData);
    } catch (e) {

      this.lastRequestData = null;
      this.emit('fetchFailed');

      throw e;
    }

    if (requestData === this.lastRequestData) {
      AnalyticsService.pushEcommerceItems(data.ga4DatalayerItems);

      data.productions = productionsFilter(data.productions);
      if (this.dataTransform !== null) {
        data = this.dataTransform(data);
      }
      this.lastResult = data;
      this.emit('fetchEnd');

      return data;
    }

    return null;
  }

  isLastResultReusable = (requestData) => {
    const { lastRequestData: last, lastResult } = this;

    if (last === null || lastResult === null) {
      return false;
    }

    if (
      last.startDate.getTime() <= requestData.startDate.getTime()
      && last.endDate.getTime() >= requestData.endDate.getTime()
      && last.keywords.length === requestData.keywords.length
      // Note we're only using json as a lazy equality check because
      // we know this array small, simple, and flat
      && JSON.stringify(last.keywords.sort()) === JSON.stringify(requestData.keywords.sort())
    ) {
      return true;
    }

    return false;
  }
}

export default DataStore;
